module.exports = __webpack_public_path__ + "img/other_iQOO2.0742437a.jpg";